import { Navigate } from 'react-router';
import { OFFICE_SECTIONS } from '../../shared/components/office-sections';
import { useCurrentUser } from '../../shared/features/session/components/CurrentUserProvider';
import { homePath } from '../policies/visible-sections';

/** `/`: the first section this user can open (dispatch for the office, reports for a report viewer). */
export function HomeRedirect() {
  const { state } = useCurrentUser();
  const permissions = state.status === 'authenticated' ? state.user.permissions : [];
  return <Navigate to={homePath(OFFICE_SECTIONS, permissions)} replace />;
}
